import {PriceStore} from "../../store/price.store";
import { serverSolutionPricingItems } from '../../common/items/server-solution-pricing';

export class PricesSliderPage {
    readonly active = 'active';
    private readonly percentPositions: number[];
    private readonly allPrices: readonly [number[], number[]];
    private readonly connections: string[];
    private sliderCircles: HTMLElement[];
    private sliderDynamic: HTMLElement | null;
    private price: HTMLElement | null;
    private additionalConnection: HTMLElement | null;
    private connectionsItem: HTMLElement | null;
    private currency: HTMLElement | null;

    constructor(
        private container: HTMLElement,
        private index: number,
        private priceStore: PriceStore,
    ) {
        this.percentPositions = [27, 50, 100];

        this.allPrices = structuredClone(serverSolutionPricingItems);
        this.connections = [
            '3 соединения',
            '5 соединений',
            '10 соединений'
        ];

        this.sliderCircles
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-slider-circle]'));
        this.sliderDynamic = this.container.querySelector('[data-slider-dynamic]');
        this.price = this.container.querySelector('[data-price]');
        this.additionalConnection = this.container.querySelector('[data-additional-connection]');
        this.connectionsItem = this.container.querySelector('[data-connections-item]');
        this.currency = this.container.querySelector('[data-currency]');
    }
    public initialize(): void {

        this.sliderCircles.forEach((sliderCircle: HTMLElement, index: number): void => {
            const price: number = this.allPrices[this.index][0];
            if (price && this.price) {
                this.price.innerText =
                  price.toLocaleString('ru');
            }
            sliderCircle.addEventListener('click', (): void => {
                this.priceStore.setIndexSliderConnections(this.index, index);
                if (this.sliderDynamic) {
                    this.sliderDynamic.style.width = this.percentPositions[index] + '%';
                }

                this.sliderCircles.forEach((sliderCircle: HTMLElement) => {
                    sliderCircle.classList.remove('active');
                });
                this.sliderCircles[index].classList.add('active');
                const price: number = this.allPrices[this.index][index];
                // if (allPrices && this.price) {
                //     this.price.innerText =
                //         allPrices.toLocaleString('ru');
                // }
                if (this.connectionsItem) {
                    this.connectionsItem.innerText = this.connections[index];
                }
                if (index === 2) {
                    this.additionalConnection?.classList.add('active');
                } else {
                    this.additionalConnection?.classList.remove('active');
                }
                const btn: HTMLElement
                    = this.container.querySelector('[data-default-number-connections]') as HTMLElement;
                if (btn && this.price && this.currency) {
                    if (index > 0) {
                        btn.innerText = 'Связаться';
                        this.price.innerText = 'Цена по запросу';
                        this.currency.classList.add('hidden');
                        this.price.classList.add('size')
                    } else {
                        btn.innerText = 'Связаться';
                        this.price.innerText =  price.toLocaleString('ru');
                        this.currency.classList.remove('hidden');
                        this.price.classList.remove('size');
                    }
                }
            });
        });
    }
}
